export const V2_ENDPOINT = process.env.NEXT_PUBLIC_V2_ENDPOINT || "";

/**
 * Edge cache endpoint for public read-only data (actions, triggers, x402-endpoints).
 * Falls back to V2_ENDPOINT when not set — so local dev hits the origin directly.
 * In production, points to the b3os-data-cache CF Worker for fast edge-cached responses.
 */
export const CACHE_ENDPOINT = process.env.NEXT_PUBLIC_CACHE_ENDPOINT || V2_ENDPOINT;

// Warn in development if endpoint is not configured
if (!process.env.NEXT_PUBLIC_V2_ENDPOINT && typeof window !== "undefined") {
  console.warn("[consts] NEXT_PUBLIC_V2_ENDPOINT is not configured");
}

/** Prefix for x402 payment-gated endpoint IDs (matches backend entity.X402EndpointPrefix) */
export const X402_ENDPOINT_PREFIX = "x402ep_";

/** Single source of truth for the support / contact email address. */
export const SUPPORT_EMAIL = "contact@npclabs.org";

/** Enterprise contact mailto URL — used in upgrade modals, pricing, and plan limit prompts. */
export const ENTERPRISE_CONTACT_URL = `mailto:${SUPPORT_EMAIL}?subject=Enterprise%20plan%20inquiry`;

/** Auto-fix attempt budgets (matches backend entity.MaxAutoFixAttempts / MaxCompilationFixAttempts) */
export const MAX_AUTO_FIX_ATTEMPTS = 5;
export const MAX_COMPILATION_FIX_ATTEMPTS = 5;
